import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function HairRestorationHero() {
  return <section className="relative pt-[120px] pb-[60px] lg:pt-[160px] lg:pb-[100px] overflow-hidden min-h-[500px] lg:min-h-[70vh] flex items-center" data-id="element-1317">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/ouVJ7mdSXk8FypYfx5BVPc/Hair-restoration-men.jpg)'
    }} data-id="element-1318" />
      <div className="absolute inset-0 bg-black/50" data-id="element-1319" />

      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 w-full relative z-10" data-id="element-1320">
        <AnimateOnScroll className="w-full lg:w-[55%]" data-id="element-1321">
          <div className="mb-6" data-id="element-1322">
            <span className="text-[#999999] text-[13px] font-body" data-id="element-1323">
              <a href="/treatments" className="hover:text-[#FF1493] transition-colors" data-id="element-1324">
                Treatments
              </a>{' '}
              / Medical
            </span>
          </div>

          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-1325">
            Be SEEN
          </span>

          <h1 className="text-[32px] sm:text-4xl lg:text-[56px] uppercase text-white tracking-tight mb-3 font-[600] font-[Poppins,_sans-serif] leading-none" data-id="element-1326">
            HAIR RESTORATION FOR MEN
          </h1>

          <p className="text-white text-2xl italic mb-6 opacity-80 font-serif" data-id="element-1327">
            in a nutshell
          </p>

          <div className="space-y-6" data-id="element-1328">
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-1329">
              For many men, thinning hair or the fear of going bald can be a
              significant source of concern. It's not just about appearance;
              it's about feeling confident and in control of your image. At Be
              CLINICAL, we understand how important your hair is to your overall
              self-esteem.
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-1330">
              Imagine waking up, looking in the mirror, and feeling assured
              about your hair. No more worrying about thinning spots or receding
              hairlines—just a full, healthy head of hair that reflects your
              inner confidence.{' '}
              <em data-id="element-1331">"Hair restoration is about more than just looks,"</em> says
              Dr. Fiona Frie.{' '}
              <em data-id="element-1332">
                "It's about reclaiming your confidence and starting each day
                feeling like your best self."
              </em>
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-1333">
              At Be CLINICAL, we offer cutting-edge treatments for hair
              restoration, including PRP, Exosomes, Growth Factors, topical
              solutions, and oral medications and supplements. These advanced
              therapies are designed not only to restore your hair but also to
              renew your sense of confidence and self-assurance.
            </p>
          </div>

          <Button variant="primary" size="lg" className="mt-8 w-full sm:w-auto" data-id="element-1334">
            SCHEDULE CONSULTATION
          </Button>
        </AnimateOnScroll>
      </div>
    </section>;
}